import _ from 'lodash';
import {PREFIX, actionMeta} from './meta';
import URLService from 'service/URLService';

const ty = actionMeta.identifiers;

let initState = {
    generals: []
};

export default function reducer(state = initState, action = "") {

    //console.log("action:", action.type, " payload:", action.payload)

    if (action.type.startsWith(PREFIX)) {
        switch (action.type) {
            case ty.GENERAL_BASE_RESPONSE:
                state = {
                    ...state,
                    base: action.payload.data
                }
                break;
            default:
                return state
                break;
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/storeState/general/reducer.js